<template>
  <div class="stepper-row">
    <!-- <span>数量</span> -->
    <div class="stepper">
      <div
        :class="[
          'count',
          'countdown',
          (value <= 1 || (buyMin && value <= buyMin)) && 'disable'
        ]"
        @click="countdown"
      >
        -
      </div>
      <input
        v-model="value"
        type="number"
        @input="
          val => {
            this.onCountChange(val);
          }
        "
      />
      <div
        :class="[
          'count',
          'countplus',
          ((buyLimit && value >= buyLimit) || (typeof bizStock === 'number' && bizStock >= 0 && value >= bizStock) || (value > stockNum && bizStock === null)) &&
            'disable'
        ]"
        @click="countplus"
      >
        +
      </div>
      <div v-if="isCart" class="limit-wrap">
        <i v-if="buyLimit > 0">{{ ReplaceText('XXX', buyLimit, TLang('限购x件', 'goods')) }}</i><i v-if="buyLimit > 0 && buyMin > 0">,</i><i v-if="buyMin > 0">{{ ReplaceText('XXX', buyMin, TLang('起购x件', 'goods')) }}</i>
      </div>
      <div v-if="!isCart" class="limit-wrap noCartCss" :style="{marginLeft: '8px'}">
        <i v-if="buyLimit">{{ ReplaceText('XXX', buyLimit, TLang('限购x件', 'goods')) }}</i><i v-if="buyLimit > 0 && buyMin > 1">，</i><i v-if="buyMin > 1">{{ ReplaceText('XXX', buyMin, TLang('起购x件', 'goods')) }}</i>
        <!-- <i v-if="value == stockNum">{{ReplaceText('SSS', stockNum, TLang('该商品仅剩', 'goods'))}}</i> -->
      </div>
    </div>
  </div>
</template>

<script>
import Toast from '@components/simpleToast';
export default {
  props: {
    //buyLimit为0
    buyLimit: {
      type: Number,
      default: function() {
        return 0;
      },
    },
    buyMin: Number, //buyMin 为 null时 无限制 为null传0
    stockNum: Number, // 库存
    onChange: {
      type: Function,
      default: function() {
        return () => {};
      },
    },
    defaultValue:  {
      type: Number,
      default: function() {
        return 1;
      },
    },
    isCart: {
      type: Boolean,
      default: function() {
        return 1
        false;
      },
    },
    bizStock: {
      type: Number || undefined,
      default: null
    },
  },
  data() {
    return {
      value: this.defaultValue || 1,
    };
  },
  mounted(){
    if(!this.isCart){
      this.onChange(parseInt(this.defaultValue || 1, 10));
    }
  },
  watch: {
    // buyMin: function(props) {
    //   if (props) {
    //     this.value = props;
    //     this.onChange(parseInt(props, 10));
    //   }
    // },
    defaultValue: function(props){
      // 多层组件嵌套没更新试图
      this.value = props
      // this.onChange(parseInt(props, 10));
    }
  },
  methods: {
    onCountChange(e) {
      let numVal = parseInt(e.target.value, 10);
      if (isNaN(numVal)) {
        this.value = this.buyMin > 0 ? this.buyMin : 1;
        this.onChange(this.value, 10);
        return;
      }
      if (typeof this.bizStock === 'number' && this.bizStock >= 0 && numVal > this.bizStock){
        if(this.bizStock > 0){
          if (this.buyLimit && this.bizStock >= this.buyLimit) {
            // Toast.info(this.ReplaceText('XXX', this.buyLimit, this.TLang('该商品限购', 'goods')));
            this.value = this.buyLimit;
            this.onChange(parseInt(this.buyLimit, 10));
            return;
          } else {
            this.value = this.bizStock;
            Toast.info(this.ReplaceText('SSS', this.bizStock, this.TLang('该商品仅剩', 'goods')));
            this.onChange(parseInt(this.bizStock, 10));
            return;
          }
        } else {
          this.value = this.buyMin > 0 ? this.buyMin : 1;
          this.onChange(this.value, 10);
          return;
        }
      }
      if (numVal > this.stockNum && this.bizStock === null) {
        if (this.buyLimit && this.stockNum >= this.buyLimit) {
          // Toast.info(this.ReplaceText('XXX', this.buyLimit, this.TLang('该商品限购', 'goods')));
          this.value = this.buyLimit;
          this.onChange(parseInt(this.buyLimit, 10));
          return;
        } else {
          this.value = this.stockNum;
          Toast.info(this.ReplaceText('SSS', this.stockNum, this.TLang('该商品仅剩', 'goods')));
          this.onChange(parseInt(this.stockNum, 10));
          return;
        }
      }
      if (numVal < 1) {
        this.value = this.buyMin > 0 ? this.buyMin : 1;
        this.onChange(this.value, 10);
        return;
      }
      if (this.buyLimit && numVal >= this.buyLimit) {
        this.value = this.buyLimit;
        // Toast.info(this.ReplaceText('XXX', this.buyLimit, this.TLang('该商品限购', 'goods')));
        this.onChange(parseInt(this.buyLimit, 10));
        return;
      }
      if (this.buyMin && numVal <= this.buyMin) {
        this.value = this.buyMin;
        // Toast.info(this.ReplaceText('QQQ', this.buyMin, this.TLang('该商品起购', 'goods')));
        this.onChange(parseInt(this.buyMin, 10));
        return;
      }
      this.onChange(numVal);
    },
    countdown() {
      if (this.value <= 1) {
        this.value = 1;
        this.onChange(1, 10);
        return;
      }
      if (this.buyMin && this.value <= this.buyMin) {
        this.value = this.buyMin;
        Toast.info(this.ReplaceText('QQQ', this.buyMin, this.TLang('该商品起购', 'goods')));
        // this.onChange(this.buyMin, 10);
        return;
      }
      this.value--;
      this.onChange(parseInt(this.value, 10));
    },
    countplus() {
      if(typeof this.bizStock === 'number' && this.bizStock >= 0) {
        if (this.bizStock > 0) {
          if (this.value >= this.bizStock) {
            this.value = this.bizStock;
            Toast.info(this.ReplaceText('SSS', this.bizStock, this.TLang('该商品仅剩', 'goods')));
            // this.onChange(parseInt(this.bizStock, 10));
            return;
          }
          if (this.buyLimit && this.value >= this.buyLimit) {
            this.value = this.buyLimit;
            Toast.info(this.ReplaceText('XXX', this.buyLimit, this.TLang('该商品限购', 'goods')));
            // this.onChange(this.buyLimit, 10);
            return;
          }
          this.value++;
          this.onChange(parseInt(this.value, 10));
        } else {
          this.value = 1;
          this.onChange(1, 10);
          return;
        }
      } else if(this.stockNum > 0){
        if (this.value >= this.stockNum) {
          this.value = this.stockNum;
          Toast.info(this.ReplaceText('SSS', this.stockNum, this.TLang('该商品仅剩', 'goods')));
          // this.onChange(parseInt(this.stockNum, 10));
          return;
        }
        if (this.buyLimit && this.value >= this.buyLimit) {
          this.value = this.buyLimit;
          Toast.info(this.ReplaceText('XXX', this.buyLimit, this.TLang('该商品限购', 'goods')));
          // this.onChange(this.buyLimit, 10);
          return;
        }
        this.value++;
        this.onChange(parseInt(this.value, 10));
      }
    },
  },
};
</script>

<style lang="less" scoped>
.stepper-row {
  display: flex;
  align-items: center;
  span {
    font-size: 12px;
    color: rgba(153, 153, 153, 1);
  }
  .stepper {
    margin-left: 24px;
    display: flex;
    .count {
      border: 1px solid rgba(229, 229, 229, 1);
      width: 38px;
      height: 38px;
      text-align: center;
      color: #333333;
      font-size: 24px;
      line-height: 38px;
      &::selection {
        background: transparent;
      }
    }
    .disable {
      color: #ccc;
      &:hover {
        cursor: not-allowed;
      }
    }
    input {
      text-align: center;
      border: 1px solid rgba(229, 229, 229, 1);
      border-left: none;
      border-right: none;
      height: 38px;
      width: 56px;
      padding: 0;
      font-size: 16px;
      color: rgba(17, 17, 17, 1);
    }
    .limit-wrap {
      width: 180px;
      margin-left: -36px;
      text-align: center;
      i {
        font-size: 12px;
        color: rgba(244, 69, 69, 1);
        line-height: 40px;
        // margin-left: 16px;
      }
    }
    .noCartCss {
      width: auto;
      text-align: left;
      margin-left: 0;
    }
    
    /* 谷歌 */
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      -webkit-appearance: none;
      appearance: none;
      margin: 0;
    }
    /* 火狐 */
    input {
      -moz-appearance: textfield;
    }
  }
  &:hover {
    cursor: pointer;
  }
}
</style>
